import ReactDOMServer from "react-dom/server";

export const svgToDataURL = (svg) => {
  const svgString = ReactDOMServer.renderToString(svg);
  return `data:image/svg+xml;base64,${window.btoa(svgString)}`;
};
